export enum DefaultPricingType {
  BASE_MARGIN = 'baseMargin',
  BASE_DISCOUNT = 'baseDiscount',
}
